import api from "./api";

export const getSalaryStructureReport = async (params) => {
  try {
    const response = await api.get(`/api/salary-structure/report`, { params });
    return response;
  } catch (error) {
    console.error("Error fetching salary structure report:", error);
    throw error; // rethrow so component can handle it
  }
};




export const getEmployeeBasedOnDistrict = async (district) => {
  try {
    const response = await api.get(`/api/employee-posting/by-district/${district}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching salary structure report:", error);
    throw error; // rethrow so component can handle it
  }
};

export const fetchSalaryStructureReport = async (filters) => {
  try {
    const response = await api.get("/api/salary-structure/filter", {
      params: filters,
    });

    // Handle both possible API response shapes
    const data = Array.isArray(response.data)
      ? response.data
      : response.data.employeeWiseReport || [];

    return data.map((item) => ({
      ...item,
      casualLeave: item.casualLeave || 0,
      absentDays: item.absentDays || 0,
    }));
  } catch (error) {
    console.error("❌ Error fetching salary structure report:", error);
    throw error; // rethrow for component to handle
  }
};

export const fetchPayslipData = async (filters) => {
  try {
    const response = await api.get("/api/salary-structure/payslip", {
      params: filters,
    });

    // Normalize the response data (some APIs may return a single object)
    const data = Array.isArray(response.data)
      ? response.data
      : [response.data];

    return data;
  } catch (error) {
    console.error("❌ Error fetching payslip data:", error);
    throw error; // rethrow so component can handle errors
  }
};
export const fetchPayrollProcessData = async (filters) => {
  try {
    const response = await api.get("/api/salary-structure/calculate", {
      params: filters,
    });

    // ✅ Handle API-level errors (if API returns an `error` field)
    if (response.data?.error) {
      return { error: response.data.error, data: [] };
    }

    // ✅ Ensure data is always returned as an array
    const data = Array.isArray(response.data)
      ? response.data
      : [response.data];

    return { data };
  } catch (error) {
    console.error("❌ Error fetching payroll process data:", error);
    throw error;
  }
};